import { FC } from 'react'
import styled from 'styled-components'
import { useSetRecoilState } from 'recoil'
import { inputState, isInViewFooterState, stepState } from '../../../states/messageState'
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { useCheckPhone } from '../../../hooks/useCheckPhone'
//components
import { FooterContent } from '../FooterContent'
import { Button } from '../../Button'

export const ChooseChangeEmail: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()
  const { checkPhone } = useCheckPhone()
  const setInput = useSetRecoilState(inputState)
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)

  /**メールアドレス変更可否によってそのまま住所チェックorメールアドレスチェックを行う */
  const handleSubmitChooseEmail = async (isChangeEmail: boolean) => {
    setIsInViewFooter(false)
    setInput('')
    await handleAddSenderParent('user', isChangeEmail ? 'はい' : 'いいえ')

    //メールの変更がある場合、APIリクエストせずメールアドレスを更新するステップへ
    if (isChangeEmail) {
      await handleAddSenderParent('bot', `変更後のメールアドレスを入力してください`)
      handleInViewFooter()
      setCurrentStep('inputUpdateEmail')
      return
    }

    await checkPhone(false)
  }

  return (
    <FooterContent isWide={false}>
      <FlexWrap>
        <Button buttonType="outlined" onClick={() => handleSubmitChooseEmail(false)}>
          いいえ
        </Button>
        <Space size={20} />
        <Button buttonType="outlined" onClick={() => handleSubmitChooseEmail(true)}>
          はい
        </Button>
      </FlexWrap>
    </FooterContent>
  )
}

const FlexWrap = styled.div`
  display: flex;
`
const Space = styled.div<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: 1px;
`
